export const getBagsLabel = (bagsFilterValue: number) => {
  return `${bagsFilterValue} or more bags`;
};
